export const MobileNumberValidation = (mobileNumber) => {
    var RegxItem = /^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/;
    if (RegxItem.test(mobileNumber)) {
        return {
            validNumber: "+98" + mobileNumber.substring(1, mobileNumber.length),
            isValid: true
        };
    }
    else {
        return {
            validNumber: "Invalid MobileNumber",
            isValid: false
        };
    }
}